// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 224 ? "register" : chunkId) + "." + {"224":"4773d6a6","265":"8d97b3cd","572":"b4cc3def","980":"10a7650a"}[chunkId] + ".css";
};